import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { Spin } from 'antd';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredGroups?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredGroups }) => {
  const auth = useAuth();
  const location = useLocation();

  if (auth.isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!auth.isAuthenticated) {
    const callbackUrl = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?callbackUrl=${callbackUrl}`} replace />;
  }

  if (auth.error) {
    return <Navigate to="/login?error=AuthError" replace />;
  }

  if (requiredGroups && requiredGroups.length > 0) {
    const userGroups = auth.user?.profile?.groups || [];
    const hasRequiredGroups = requiredGroups.every(requiredGroup => {
      return userGroups.some(userGroup => {
        if (requiredGroup.endsWith('/')) {
          return userGroup.startsWith(requiredGroup);
        }
        return userGroup === requiredGroup;
      });
    });

    if (!hasRequiredGroups) {
      return <Navigate to="/" replace />;
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute;
